import { useMemo } from "react";
import { ReadingAssessmentTestResult } from "types/tests";
import { calculateReadingRisk, ReadingRiskResult } from "../utils/ReadingRiskUtils";

export function useReadingAssessmentRisk(
  testResult: ReadingAssessmentTestResult | undefined,
): ReadingRiskResult | null {
  return useMemo(() => calculateReadingRisk(testResult), [testResult]);
}
